(function ($) {
	const blockSlug = 'columntext';
	const initializeBlock = function ($block) {

		// START your JS code

		// END your JS code

	};

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		$('.acf-block-' + blockSlug).each(function () {

			initializeBlock($(this));

		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=' + blockSlug, initializeBlock);
	}
})(jQuery);
